import { render } from "./formDialog.vue?vue&type=template&id=2f472230&scoped=true"
import script from "./formDialog.vue?vue&type=script&lang=js"
export * from "./formDialog.vue?vue&type=script&lang=js"

import "./formDialog.vue?vue&type=style&index=0&id=2f472230&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f472230"]])

export default __exports__